import { z } from "zod";

export const SearchSchema = z.object({
  patternId: z.string().optional(),
  new: z.string().optional(),
  select: z.string().optional(),
});

export type SearchSchema = z.infer<typeof SearchSchema>;
